import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLLMDialog } from "../hooks";
import { cn } from "@/lib/utils";

export const LLMFilters = () => {
  const { t } = useTranslation();
  const {
    searchQuery,
    selectedProvider,
    providerCategories,
    updateSearchQuery,
    selectProvider,
  } = useLLMDialog();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateSearchQuery(e.target.value);
  };

  return (
    <>
      {/* Search */}
      <div className="flex items-center gap-2 mb-4">
        <div className="relative flex-1">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-text-tertiary dark:text-gray-400" />
          <Input
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder={t("llmSelection.searchPlaceholder")}
            className={cn(
              "h-11 pl-10 pr-4 rounded-xl",
              // "bg-bg-secondary/60 dark:bg-gray-800/60",
              // "border-border-secondary dark:border-gray-700",
              "text-text-primary dark:text-gray-100",
              "placeholder:text-text-tertiary dark:placeholder:text-gray-500",
              "focus-visible:ring-2 focus-visible:ring-indigo-500/30 dark:focus-visible:ring-indigo-400/25",
              "focus-visible:ring-offset-0"
            )}
          />
        </div>
      </div>

      {/* Provider Categories */}
      {providerCategories.length > 0 && (
        <div className="flex gap-2 overflow-x-auto pb-2">
          {providerCategories.map((category) => (
            <Button
              key={category.slug}
              variant={
                (selectedProvider === "all" && category.slug === "all") ||
                selectedProvider === category.slug
                  ? "default"
                  : "outline"
              }
              size="sm"
              onClick={() => selectProvider(category.slug)}
              className="whitespace-nowrap"
            >
              <span
                className={`text-sm font-medium ${
                  selectedProvider === category.slug
                    ? "text-foreground"
                    : "text-muted-foreground"
                }`}
              >
                {category.name}
              </span>
            </Button>
          ))}
        </div>
      )}
    </>
  );
};
